import { render, staticRenderFns } from "./EditOtherIncomeEntries.vue?vue&type=template&id=92444582"
import script from "./EditOtherIncomeEntries.vue?vue&type=script&lang=js"
export * from "./EditOtherIncomeEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports